import { apiAxios } from '@/api/axios';
import type { MeResponse } from '@/api/types/MeResponse';

// `GET /api/me` — returns the current authenticated user's profile derived
// from the JWT + Keycloak attributes. The api is the source of truth here
// (not the FE's decoded JWT), because the `phoneNumber` attribute is loaded
// server-side via the cached KC Admin REST call.
export const fetchMe = async (): Promise<MeResponse> => {
  const response = await apiAxios.get<MeResponse>('/api/me');
  return response.data;
};
